import React from 'react';
import { FormProps } from './types';

function TextArea({
  question, name, onChange, value,
}: FormProps, ref) {
  if (question.type !== 'textarea') return null;

  return (
    <>
      <div className="dynamic-form-label">{question.label}</div>
      <div className="dynamic-form-input">
        <textarea ref={ref} name={name} onChange={onChange} value={value} />
      </div>
    </>
  );
}

export default React.forwardRef(TextArea);
